"use strict";

import $ from "jquery";

export default function(element) {
  const toolbox = element;

  toolbox.bind("wheel", function (e) {
    if (this.scrollHeight <= $(this).innerHeight()) {
      return; // Element isn't big enough to be scrollable
    }

    // Only allow scrolling of element, do not scroll page when at top/bottom
    if(e.originalEvent.deltaY <= 0) {
      if(this.scrollTop === 0) {
        e.preventDefault();
      }
    } else {
      if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
        e.preventDefault();
      }
    }
  });
}
